export const LOADING_START = "loading:start";
export const LOADING_STOP = "loading:stop";

export const PROGRESS_UPDATE = "progress:update";
export const PROGRESS_RECORD = "progress:record";

export const COURSE_UPDATE = "course:update";
export const COURSE_INIT = "course:init";
export const COURSE_SET_LEVEL = "course:set-level";

export const LEVEL_FETCH = "level:fetch";
export const LEVEL_OPEN = "level:open";
export const LEVEL_CLOSE = "level:close";
export const LEVEL_UPDATE = "level:update";

export const MODULE_OPEN = "module:open";
export const MODULE_UPDATE = "module:update";

export const RESPONSES_SET = "responses:set";
export const RESPONSES_RESET = "responses:reset";

export const REGISTRATION_UPDATE = "registration:update";
export const REGISTRATION_ERRORS_SET = "registration:set-errors";
